export default __webpack_public_path__ + "static/media/sketch-club-tn.b62ed747.png";